import { render } from "./circularProgress.vue?vue&type=template&id=23395e9c&scoped=true&ts=true"
import script from "./circularProgress.vue?vue&type=script&lang=ts"
export * from "./circularProgress.vue?vue&type=script&lang=ts"

import "./circularProgress.vue?vue&type=style&index=0&id=23395e9c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23395e9c"]])

export default __exports__